import React from "react";

import {
  COURSE_LOGOS,
  HorizontalCourseLogoMarquee,
  VerticalCourseLogoMarquee,
} from "../CourseLogoMarquee/CourseLogoMarquee";
import { ClockIcon, ProjectsIcon } from "../../icons";
import { COURSE_HEADER_ICONS } from "./courseAssets";
import useWebflowTabs from "../../utils/useWebflowTabs";

import "./CoursesSection.css";

export default function CoursesSection() {
  useWebflowTabs();
  return (
    <>
      <section id="our-courses" className="courses-you-can-choose-sec">
          <div className="courses-online-offline">
            <h2 className="h2-heading">Courses You Can Choose</h2>
            <div data-current="Tab 2" data-easing="ease" data-duration-in="300" data-duration-out="100" className="tabs-56 w-tabs">
              <div className="tabs-menu-239 w-tab-menu">
                <a href="#online-courses" data-w-tab="Tab 1" id="online-our-courses" className="tab-link-tab-1-23 track-button w-inline-block w-tab-link">
                  <div>Online</div>
                </a>
                <a href="#training-center-courses" data-w-tab="Tab 2" id="in-classroom-our-courses" className="tab-link-tab-1-23 track-button w-inline-block w-tab-link w--current">
                  <div>Training Center</div>
                </a>
              </div>
              <div className="tabs-content-49 w-tab-content">
                <div data-w-tab="Tab 1" className="w-tab-pane">
                  <div className="courses-container-off-online">
                    <div className="python-online-course">
                      <div className="left-of-main-card"><img src={COURSE_HEADER_ICONS.stack} loading="lazy" alt="" className="image-8128822646 course-card__icon" />
                        <div className="text-block-941288240437">COURSE 1</div>
                        <h3 className="python-fullstack-heading">MERN Full Stack</h3>
                        <div className="project-time-python">
                          <div className="div-block-1831980521448587"><ClockIcon />
                            <div className="text-block-941288240435">8 months</div>
                          </div>
                          <div className="div-block-1831980521448587"><ProjectsIcon />
                            <div className="text-block-941288240435">10+ real time projects</div>
                          </div>
                        </div>
                        <div className="scroll-mobile-off-online">
                          <div className="left-side-move">
                            <HorizontalCourseLogoMarquee logos={COURSE_LOGOS.mobileFull} direction="left" />
                          </div>
                          <div className="mobile-python-mask"></div>
                        </div><svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 280 1" fill="none" className="svg-in-mobile-hide">
                          <line y1="0.5" x2="280" y2="0.5" stroke="currentColor" stroke-dasharray="6 6"></line>
                        </svg>
                      </div>
                      <div className="right-of-main-card">
                        <div className="up-side-courses">
                          <VerticalCourseLogoMarquee logos={COURSE_LOGOS.mernUp} direction="up" />
                        </div>
                        <div className="down-side-courses">
                          <VerticalCourseLogoMarquee logos={COURSE_LOGOS.mernDown} direction="down" />
                        </div>
                        <div className="python-mask-desktop"></div>
                        
                      </div><svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 156 86" fill="none" className="svg-270">
                        <path d="M78 -57L91.0777 -22.9979C92.9108 -18.232 93.8273 -15.849 95.2526 -13.8445C96.5158 -12.068 98.068 -10.5158 99.8445 -9.25261C101.849 -7.82733 104.232 -6.91079 108.998 -5.07771L143 8L108.998 21.0777C104.232 22.9108 101.849 23.8273 99.8445 25.2526C98.068 26.5158 96.5158 28.068 95.2526 29.8445C93.8273 31.849 92.9108 34.232 91.0777 38.9979L78 73L64.9223 38.9979C63.0892 34.232 62.1727 31.849 60.7474 29.8445C59.4842 28.068 57.932 26.5158 56.1555 25.2526C54.151 23.8273 51.7681 22.9108 47.0021 21.0777L13 8L47.002 -5.07771C51.768 -6.91078 54.151 -7.82732 56.1555 -9.25261C57.932 -10.5158 59.4842 -12.068 60.7474 -13.8445C62.1727 -15.849 63.0892 -18.232 64.9223 -22.9979L78 -57Z" stroke="#EDE9FE" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round"></path>
                      </svg>
                    </div>
                    <div className="java-online-card">
                      <div className="left-of-main-card"><img src={COURSE_HEADER_ICONS.java} loading="lazy" alt="" className="image-8128822646 course-card__icon" />
                        <div className="text-block-941288240437">COURSE 2</div>
                        <h3 className="java-fullstack-heading">Java Full Stack </h3>
                        <div className="project-time-python">
                          <div className="div-block-1831980521448587"><ClockIcon />
                            <div className="text-block-941288240435">8 months</div>
                          </div>
                          <div className="div-block-1831980521448587"><ProjectsIcon />
                            <div className="text-block-941288240435">10+ real time projects</div>
                          </div>
                        </div>
                        <div className="scroll-mobile-off-online">
                          <div className="right-side-move">
                            <HorizontalCourseLogoMarquee logos={COURSE_LOGOS.mobileJava} direction="right" />
                          </div>
                          <div className="mobile-python-mask"></div>
                        </div><svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 280 1" fill="none" className="svg-in-mobile-hide">
                          <line y1="0.5" x2="280" y2="0.5" stroke="currentColor" stroke-dasharray="6 6"></line>
                        </svg>
                      </div>
                      <div className="right-of-main-card">
                        <div className="up-side-courses">
                          <VerticalCourseLogoMarquee logos={COURSE_LOGOS.mernUp} direction="up" />
                        </div>
                        <div className="down-side-courses">
                          <VerticalCourseLogoMarquee logos={COURSE_LOGOS.javaDown} direction="down" />
                        </div>
                        <div className="python-mask-desktop"></div>
                      </div><svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 156 86" fill="none" className="svg-270">
                        <path d="M78 -57L91.0777 -22.9979C92.9108 -18.232 93.8273 -15.849 95.2526 -13.8445C96.5158 -12.068 98.068 -10.5158 99.8445 -9.25261C101.849 -7.82733 104.232 -6.91079 108.998 -5.07771L143 8L108.998 21.0777C104.232 22.9108 101.849 23.8273 99.8445 25.2526C98.068 26.5158 96.5158 28.068 95.2526 29.8445C93.8273 31.849 92.9108 34.232 91.0777 38.9979L78 73L64.9223 38.9979C63.0892 34.232 62.1727 31.849 60.7474 29.8445C59.4842 28.068 57.932 26.5158 56.1555 25.2526C54.151 23.8273 51.7681 22.9108 47.0021 21.0777L13 8L47.002 -5.07771C51.768 -6.91078 54.151 -7.82732 56.1555 -9.25261C57.932 -10.5158 59.4842 -12.068 60.7474 -13.8445C62.1727 -15.849 63.0892 -18.232 64.9223 -22.9979L78 -57Z" stroke="#DBEAFE" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round"></path>
                      </svg>
                    </div>
                  </div>
                </div>
                <div data-w-tab="Tab 2" className="w-tab-pane w--tab-active">
                  <div className="courses-container-off-online">
                    <div className="main-card-courses-python"><svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 138 138" fill="none" className="svg-193">
                        <path d="M69 4L82.0777 38.0021C83.9108 42.768 84.8273 45.151 86.2526 47.1555C87.5158 48.932 89.068 50.4842 90.8445 51.7474C92.849 53.1727 95.232 54.0892 99.9979 55.9223L134 69L99.998 82.0777C95.232 83.9108 92.849 84.8273 90.8445 86.2526C89.068 87.5158 87.5158 89.068 86.2526 90.8445C84.8273 92.849 83.9108 95.232 82.0777 99.9979L69 134L55.9223 99.9979C54.0892 95.232 53.1727 92.849 51.7474 90.8445C50.4842 89.068 48.932 87.5158 47.1555 86.2526C45.151 84.8273 42.7681 83.9108 38.0021 82.0777L4 69L38.002 55.9223C42.768 54.0892 45.151 53.1727 47.1555 51.7474C48.932 50.4842 50.4842 48.932 51.7474 47.1555C53.1727 45.151 54.0892 42.768 55.9223 38.0021L69 4Z" stroke="#E0E7FF" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round"></path>
                      </svg>
                      <div className="left-of-main-card"><img src={COURSE_HEADER_ICONS.stack} loading="lazy" alt="" className="image-8128822646 course-card__icon" />
                        <div className="text-block-941288240437">COURSE 1</div>
                        <h3 className="heading-3671144">Python Full Stack with <span className="text-span-1790">GenAI</span></h3>
                        <div className="project-time-python">
                          <div className="div-block-1831980521448587"><ClockIcon />
                            <div className="text-block-941288240435">6 months</div>
                          </div>
                          <div className="div-block-1831980521448587"><ProjectsIcon />
                            <div className="text-block-941288240435">10+ real time projects</div>
                          </div>
                        </div>
                        <div className="scroll-mobile-off-online">
                          <div className="left-side-move">
                            <HorizontalCourseLogoMarquee logos={COURSE_LOGOS.mobileFull} direction="left" />
                          </div>
                          <div className="mobile-python-mask"></div>
                        </div><svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 280 1" fill="none" className="svg-in-mobile-hide">
                          <line y1="0.5" x2="280" y2="0.5" stroke="currentColor" stroke-dasharray="6 6"></line>
                        </svg>
                      </div>
                      <div className="right-of-main-card">
                        <div className="up-side-courses">
                          <VerticalCourseLogoMarquee logos={COURSE_LOGOS.mernUp} direction="up" />
                        </div>
                        <div className="down-side-courses">
                          <VerticalCourseLogoMarquee logos={COURSE_LOGOS.mernDown} direction="down" />
                        </div>
                        <div className="python-mask-desktop"></div>
                        
                      </div>
                    </div>
                    <div className="java-offline-card"><svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 138 138" fill="none" className="svg-193">
                        <path d="M69 4L82.0777 38.0021C83.9108 42.768 84.8273 45.151 86.2526 47.1555C87.5158 48.932 89.068 50.4842 90.8445 51.7474C92.849 53.1727 95.232 54.0892 99.9979 55.9223L134 69L99.998 82.0777C95.232 83.9108 92.849 84.8273 90.8445 86.2526C89.068 87.5158 87.5158 89.068 86.2526 90.8445C84.8273 92.849 83.9108 95.232 82.0777 99.9979L69 134L55.9223 99.9979C54.0892 95.232 53.1727 92.849 51.7474 90.8445C50.4842 89.068 48.932 87.5158 47.1555 86.2526C45.151 84.8273 42.7681 83.9108 38.0021 82.0777L4 69L38.002 55.9223C42.768 54.0892 45.151 53.1727 47.1555 51.7474C48.932 50.4842 50.4842 48.932 51.7474 47.1555C53.1727 45.151 54.0892 42.768 55.9223 38.0021L69 4Z" stroke="#FFEDD5" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round"></path>
                      </svg>
                      <div className="left-of-main-card"><img src={COURSE_HEADER_ICONS.java} loading="lazy" alt="" className="image-8128822646 course-card__icon" />
                        <div className="text-block-941288240437">COURSE 2</div>
                        <h3 className="java-fullstack-genai-head">Java Full Stack with <span className="text-span-1791">GenAI</span></h3>
                        <div className="project-time-python">
                          <div className="div-block-1831980521448587"><ClockIcon />
                            <div className="text-block-941288240435">6 months</div>
                          </div>
                          <div className="div-block-1831980521448587"><ProjectsIcon />
                            <div className="text-block-941288240435">10+ real time projects</div>
                          </div>
                        </div>
                        <div className="scroll-mobile-off-online">
                          <div className="right-side-move">
                            <HorizontalCourseLogoMarquee logos={COURSE_LOGOS.mobileJava} direction="right" />
                          </div>
                          <div className="java-mobile-mask"></div>
                        </div><svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 280 1" fill="none" className="svg-in-mobile-hide">
                          <line y1="0.5" x2="280" y2="0.5" stroke="currentColor" stroke-dasharray="6 6"></line>
                        </svg>
                      </div>
                      <div className="right-of-main-card">
                        <div className="up-side-courses">
                          <VerticalCourseLogoMarquee logos={COURSE_LOGOS.mernUp} direction="up" />
                        </div>
                        <div className="down-side-courses">
                          <VerticalCourseLogoMarquee logos={COURSE_LOGOS.javaDown} direction="down" />
                        </div>
                        <div className="java-card-mask"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
    </>
  );
}
